
import { IntlProvider } from "react-intl";
import useCommon from "../hooks/Common/useCommon";
import { ConfigProvider } from "react-vant";
// 引入英文语言包
import enUS from "react-vant/es/locale/lang/en-US";
import zhCH from "react-vant/es/locale/lang/zh-CN";
import en from "./en-US.json";
import zh from "./zh-CN.json";

const messages = {
  en,
  zh,
};
export default function Intl({ children }) {
  const { lang } = useCommon();
  return (
    <IntlProvider locale={lang} messages={messages[lang]}>
      <ConfigProvider locale={lang === 'en' ?enUS:zhCH} > {children} </ConfigProvider>
    </IntlProvider>
  );
}
